import { AdministrationAreaDialog } from "../configurator/renderer/components/AdministrationAreaDialog/AdministrationAreaDialog";

import { JSX } from "react";

import { AdministrationAreaFetchError } from "./AdministrationAreaFetchError";
import { useOnboardingStatus } from "./useOnboardingStatus";

export function OnboardingGate(): JSX.Element | null {
  const status = useOnboardingStatus();

  switch (status) {
    case "needs-administration-area":
      return <AdministrationAreaDialog />;
    case "fetch-error":
      return <AdministrationAreaFetchError />;
    case "checking":
    case "ready":
      return null;
  }
}
